import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CategoryGrid = () => {
  const categories = [
    {
      id: 1,
      name: "Fresh Produce",
      icon: "Apple",
      image: "https://images.unsplash.com/photo-1610832958506-aa56368176cf?w=200&h=200&fit=crop",
      itemCount: "250+ items",
      color: "bg-green-50 text-green-600",
      link: "/product-catalog-category-browse?category=produce"
    },
    {
      id: 2,
      name: "Dairy & Eggs",
      icon: "Milk",
      image: "https://images.pexels.com/photos/236010/pexels-photo-236010.jpeg?w=200&h=200&fit=crop",
      itemCount: "120+ items",
      color: "bg-blue-50 text-blue-600",
      link: "/product-catalog-category-browse?category=dairy"
    },
    {
      id: 3,
      name: "Meat & Seafood",
      icon: "Fish",
      image: "https://images.pixabay.com/photo/2016/01/22/02/13/meat-1155132_1280.jpg?w=200&h=200&fit=crop",
      itemCount: "80+ items",
      color: "bg-red-50 text-red-600",
      link: "/product-catalog-category-browse?category=meat"
    },
    {
      id: 4,
      name: "Bakery",
      icon: "Croissant",
      image: "https://images.unsplash.com/photo-1509440159596-0249088772ff?w=200&h=200&fit=crop",
      itemCount: "90+ items",
      color: "bg-orange-50 text-orange-600",
      link: "/product-catalog-category-browse?category=bakery"
    },
    {
      id: 5,
      name: "Beverages",
      icon: "Coffee",
      image: "https://images.pexels.com/photos/544961/pexels-photo-544961.jpeg?w=200&h=200&fit=crop",
      itemCount: "150+ items",
      color: "bg-purple-50 text-purple-600",
      link: "/product-catalog-category-browse?category=beverages"
    },
    {
      id: 6,
      name: "Snacks",
      icon: "Cookie",
      image: "https://images.pixabay.com/photo/2017/05/07/08/56/blank-2293543_1280.jpg?w=200&h=200&fit=crop",
      itemCount: "200+ items",
      color: "bg-yellow-50 text-yellow-600",
      link: "/product-catalog-category-browse?category=snacks"
    },
    {
      id: 7,
      name: "Frozen Foods",
      icon: "Snowflake",
      image: "https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=200&h=200&fit=crop",
      itemCount: "100+ items",
      color: "bg-cyan-50 text-cyan-600",
      link: "/product-catalog-category-browse?category=frozen"
    },
    {
      id: 8,
      name: "Household",
      icon: "Home",
      image: "https://images.pexels.com/photos/4239091/pexels-photo-4239091.jpeg?w=200&h=200&fit=crop",
      itemCount: "180+ items",
      color: "bg-gray-50 text-gray-600",
      link: "/product-catalog-category-browse?category=household"
    }
  ];

  return (
    <div className="mb-12">
      <div className="flex items-center justify-between mb-6">
        <h2 className="font-heading font-heading-semibold text-2xl text-text-primary">
          Shop by Category
        </h2>
        <Link to="/product-catalog-category-browse">
          <button className="flex items-center space-x-2 text-primary hover:text-secondary transition-smooth">
            <span className="font-body-semibold">View All</span>
            <Icon name="ArrowRight" size={16} />
          </button>
        </Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-4 md:gap-6">
        {categories.map((category) => (
          <Link
            key={category.id}
            to={category.link}
            className="group bg-surface rounded-card p-4 shadow-card hover:shadow-medium transition-smooth border border-border-light hover:border-primary"
          >
            <div className="text-center">
              <div className="relative mb-3">
                <div className="w-16 h-16 mx-auto rounded-full overflow-hidden mb-2">
                  <Image
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-smooth"
                  />
                </div>
                <div className={`absolute -top-1 -right-1 w-8 h-8 rounded-full ${category.color} flex items-center justify-center`}>
                  <Icon name={category.icon} size={16} />
                </div>
              </div>
              <h3 className="font-body-semibold text-sm md:text-base text-text-primary mb-1 group-hover:text-primary transition-smooth">
                {category.name}
              </h3>
              <p className="font-caption text-xs text-text-secondary">
                {category.itemCount}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategoryGrid;